import {NextPageWithLayout} from "./_app"
import {ReactElement} from "react"
import {Privacy} from "../components/Atoms/Privacy"

const PrivacyPage: NextPageWithLayout = () => {
    return <Privacy />
}

export const getStaticProps = async (): Promise<unknown> => {
    return {
        props: { isPublicRoute: true },
    }
}


PrivacyPage.getLayout = (page: ReactElement) => <div style={{position: "fixed", right: 0, left: 0, top: 0, bottom: 0, overflowY: "auto"}}>{page}</div>

export default PrivacyPage
